import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroVideo from '../assets/images/may-sitting-near-waterfall-pokemon-emerald-pixel-wallpaperwaifu-com.mp4';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleLoadedData = () => {
        video.setAttribute('data-loaded', 'true');
      };

      const handleCanPlay = () => {
        video.setAttribute('data-loaded', 'true');
      };
      // Defer playback start to after fonts are loaded to reduce reflow
      if (document && 'fonts' in document) {
        document.fonts.ready.then(() => {
          try { video.play().catch(() => {}); } catch {}
        });
      }

      video.addEventListener('loadeddata', handleLoadedData);
      video.addEventListener('canplay', handleCanPlay);

      return () => {
        video.removeEventListener('loadeddata', handleLoadedData);
        video.removeEventListener('canplay', handleCanPlay);
      };
    }
  }, []);

  return (
    <section className="hero" id="hero">
      {/* Video Background */}
      <video 
        ref={videoRef}
        className="hero-video-bg" 
        autoPlay 
        muted 
        loop 
        playsInline
        preload="metadata"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1
        }}
      >
        <source src={HeroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <div className="container">
        <p className="hero-subtitle">SA's premier</p>
        <h1 className="h1 hero-title">
          TCG<br />
          STORE
        </h1>
        <div className="btn-group">
          <Link to="/shop" className="btn btn-primary">
            <span>Shop now</span>
            <ion-icon name="play-circle"></ion-icon>
          </Link>
          <a href="contact" className="btn btn-link">Contact Us</a>
        </div>
        
        {/* SEO Content */}
        <div className="hero-seo-content" style={{
          marginTop: '40px',
          textAlign: 'center',
          maxWidth: '800px',
          margin: '40px auto 0',
          padding: '0 20px'
        }}>
          <p style={{
            fontSize: 'clamp(18px, 3.5vw, 22px)',
            fontWeight: 'bold',
            color: 'var(--white)',
            lineHeight: '1.6',
            textShadow: '0 2px 4px rgba(0,0,0,0.7)',
            marginBottom: '16px'
          }}>
            Premium Pokémon, One Piece and Other Trading Cards in South Africa
          </p>
          <p style={{
            fontSize: 'clamp(16px, 3vw, 20px)',
            fontWeight: 'bold',
            color: 'var(--platinum)',
            lineHeight: '1.5',
            textShadow: '0 2px 4px rgba(0,0,0,0.7)',
            marginBottom: '12px'
          }}>
            Booster Packs • Singles • Accessories • Tournaments
          </p>
          <p style={{
            fontSize: 'clamp(15px, 2.8vw, 18px)',
            fontWeight: 'bold',
            color: 'var(--light-gray)',
            lineHeight: '1.4',
            textShadow: '0 2px 4px rgba(0,0,0,0.7)'
          }}>
            Authentic TCG Products • Competitive Gaming • Community Events
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
